<!-- TEMPLATE -->
<template>

    <!-- NAVBAR -->
    <nav id="navbar" class="navbar navbar-expand-md navbar-dark gradient-custom fixed-top py-2">
        <div class="container-fluid">

            <!-- MOBILE BUTTON -->
            <button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapsibleNavId" aria-controls="collapsibleNavId" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- NAVBAR LIST -->
            <div class="collapse navbar-collapse justify-content-center fw-light" id="collapsibleNavId">
                <ul class="navbar-nav mb-2 mb-lg-0 fs-4">
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="https://kernelhearts.com">Home</a>
                    </li>
                    <!-- <li class="nav-item mx-2">
                        <a class="nav-link" href="#about">About</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="#gallery">Story</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="#characters">Your Squad</a>
                    </li> -->
                    <li class="nav-item mx-2">
                        <a class="nav-link fw-normal"
                            href="https://store.steampowered.com/app/2902170/Kernel_Hearts/">Wishlist on Steam</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link fw-normal"
                            href="https://store.epicgames.com/es-MX/p/kernel-hearts-809ae2">Wishlist on Epic Games</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="https://discord.gg/e8NvKhXqrU">Join our Discord</a>
                    </li>
                    <li class="nav-item mx-2">
                        <a class="nav-link" href="https://ephemeragames.com">The Team</a>
                    </li>
                    <!-- <li class="nav-item mx-2">
                        <a class="nav-link" href="https://link.whitethorngames.com/KernelHearts-PressKit">Press Kit</a>
                    </li> -->
                </ul>
            </div>

        </div>
    </nav>

</template>

<!-- SCRIPT -->
<script>
export default {
    name: 'NavbarComponent',
    // props: {},
    data: function () {
        return {}
    },
    // computed: {},
    // methods: {},
    // watch: {},
    // components: {},
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
.navbar {
    width: 100%;
}

.navbar-expand-md,
.navbar-nav {
    flex-wrap: wrap;
    justify-content: center;
}

.gradient-custom {
    background: linear-gradient(180deg, rgba(20, 0, 40, 0.6) 0%, rgba(60, 0, 240, 0) 100%);
}

ul.navbar-nav a:hover {
    color: #fff !important;
    filter: drop-shadow(0px 0px 8px rgba(255, 230, 230, .4));
}

// .navbar-nav{
//     border-radius: 20px;
//     background: linear-gradient(90deg, rgba(25, 0, 80, 0.25) 0%, rgba(25, 0, 80, 0.5) 100%);
// }</style>